/**
 *    @author:
 *    @since:
 *
 */

import { ViewportScroller } from '@angular/common';
import { Util } from 'src/refresh/service/Util';
import { IValidator } from '../_common/component/IValidator';
import { InputData } from '../_common/data/input-data';
import { BirthdayComponent } from './birth-day/birth-day.component';
import { Setup1Component} from './setup_1.component';

export class Setup1Validation extends IValidator {

       inputBornInOntario:string; 
       inputBirthday:string;
       private success: boolean;
       
       constructor(private component: Setup1Component, 
                   private birthday:BirthdayComponent,
                   private menuID:number,
                    ) {
              super();
              this.inputBornInOntario = this.component.data.eligibility.isBornInOntario;
              this.inputBirthday = this.component.data.aboutChild.birthDay;
              this.viewportScroller = this.component.viewportScroller;
       }
       private viewportScroller:ViewportScroller;
       public validate(): boolean {
       this.success = true;

          if ( Util.isEmpty(this.component.eligibility.isBornInOntario) ) {
               this.focus("isBornInOntario","radio_isBornInOntarioRadio_0").error_bornInOntario = "setup_1.emptyBornInOntario";
          }
            
          return this.birthday.validate() && this.success;
       }

       public IdOfChanged():number { 

            if (  this.inputBornInOntario !=  this.component.data.eligibility.isBornInOntario ||
                  this.inputBirthday !=  this.component.data.aboutChild.birthDay) return this.menuID;

              return 0;
       }

       private focus(tagId:string,ctrlId:string) : Setup1Component {
            if ( this.success ) {
                 this.viewportScroller.scrollToAnchor(tagId);
                 let ctrl = document.getElementById(ctrlId);
                 ///console.log(ctrl);
                 if ( ctrl ) ctrl.focus();
            }
                 
            this.success = false;
            return this.component;
       }

}

